var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "material-input__component", class: _vm.computedClasses },
    [
      _c("div", { class: { iconClass: _vm.icon } }, [
        _vm.icon
          ? _c("i", {
              staticClass: "el-input__icon material-input__icon",
              class: ["el-icon-" + _vm.icon],
            })
          : _vm._e(),
        _vm.type === "email"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue",
                },
              ],
              staticClass: "material-input",
              attrs: {
                type: "email",
                name: _vm.name,
                placeholder: _vm.fillPlaceHolder,
                readonly: _vm.readonly,
                disabled: _vm.disabled,
                autoComplete: _vm.autoComplete,
                required: _vm.required,
              },
              domProps: { value: _vm.currentValue },
              on: {
                focus: _vm.handleMdFocus,
                blur: _vm.handleMdBlur,
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.currentValue = $event.target.value
                  },
                  _vm.handleModelInput,
                ],
              },
            })
          : _vm._e(),
        _vm.type === "url"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue",
                },
              ],
              staticClass: "material-input",
              attrs: {
                type: "url",
                name: _vm.name,
                placeholder: _vm.fillPlaceHolder,
                readonly: _vm.readonly,
                disabled: _vm.disabled,
                autoComplete: _vm.autoComplete,
                required: _vm.required,
              },
              domProps: { value: _vm.currentValue },
              on: {
                focus: _vm.handleMdFocus,
                blur: _vm.handleMdBlur,
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.currentValue = $event.target.value
                  },
                  _vm.handleModelInput,
                ],
              },
            })
          : _vm._e(),
        _vm.type === "number"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue",
                },
              ],
              staticClass: "material-input",
              attrs: {
                type: "number",
                name: _vm.name,
                placeholder: _vm.fillPlaceHolder,
                step: _vm.step,
                readonly: _vm.readonly,
                disabled: _vm.disabled,
                autoComplete: _vm.autoComplete,
                max: _vm.max,
                min: _vm.min,
                minlength: _vm.minlength,
                maxlength: _vm.maxlength,
                required: _vm.required,
              },
              domProps: { value: _vm.currentValue },
              on: {
                focus: _vm.handleMdFocus,
                blur: _vm.handleMdBlur,
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.currentValue = $event.target.value
                  },
                  _vm.handleModelInput,
                ],
              },
            })
          : _vm._e(),
        _vm.type === "password"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue",
                },
              ],
              staticClass: "material-input",
              attrs: {
                type: "password",
                name: _vm.name,
                placeholder: _vm.fillPlaceHolder,
                readonly: _vm.readonly,
                disabled: _vm.disabled,
                autoComplete: _vm.autoComplete,
                max: _vm.max,
                min: _vm.min,
                required: _vm.required,
              },
              domProps: { value: _vm.currentValue },
              on: {
                focus: _vm.handleMdFocus,
                blur: _vm.handleMdBlur,
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.currentValue = $event.target.value
                  },
                  _vm.handleModelInput,
                ],
              },
            })
          : _vm._e(),
        _vm.type === "tel"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue",
                },
              ],
              staticClass: "material-input",
              attrs: {
                type: "tel",
                name: _vm.name,
                placeholder: _vm.fillPlaceHolder,
                readonly: _vm.readonly,
                disabled: _vm.disabled,
                autoComplete: _vm.autoComplete,
                required: _vm.required,
              },
              domProps: { value: _vm.currentValue },
              on: {
                focus: _vm.handleMdFocus,
                blur: _vm.handleMdBlur,
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.currentValue = $event.target.value
                  },
                  _vm.handleModelInput,
                ],
              },
            })
          : _vm._e(),
        _vm.type === "text"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentValue,
                  expression: "currentValue",
                },
              ],
              staticClass: "material-input",
              attrs: {
                type: "text",
                name: _vm.name,
                placeholder: _vm.fillPlaceHolder,
                readonly: _vm.readonly,
                disabled: _vm.disabled,
                autoComplete: _vm.autoComplete,
                minlength: _vm.minlength,
                maxlength: _vm.maxlength,
                required: _vm.required,
              },
              domProps: { value: _vm.currentValue },
              on: {
                focus: _vm.handleMdFocus,
                blur: _vm.handleMdBlur,
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.currentValue = $event.target.value
                  },
                  _vm.handleModelInput,
                ],
              },
            })
          : _vm._e(),
        _c("span", { staticClass: "material-input-bar" }),
        _c("label", { staticClass: "material-label" }, [_vm._t("default")], 2),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }